<template>
  <div class="pk-flex pk-imageview">
    <div v-if="showLoading"
     style="margin:50px 50px; z-index: 100; position:absolute;">
      <img src="../assets/icons/loading.gif"
       style="height:20px">
      <span v-if="inputData && inputData.dbImageInfo && inputData.dbImageInfo.name"> {{inputData.dbImageInfo.name}} <br> (creating tiles of the image... please wait a moment)</span>
    </div>
    <!--<div class="pk-imageview-side pk-flex"
     style="margin-right:10px">
      <img src="../assets/icons/previous.svg"
       @click="prev">
    </div>-->
    <div :id="containerId"
     class="pk-flex__1 pk-imageview-body pk-flex"
     style="position:relative; width:100%; height:100%">
    </div>
    <!--<div class="pk-imageview-side pk-flex"
     style="margin-left:10px; justify-content: flex-end;">
      <img src="../assets/icons/next.svg"
       @click="next">
    </div>-->
  </div>
</template>

<script>
import * as OpenSeadragon from 'openseadragon';
import { PKConfig } from '../config';
const pkConfig = require('../config.json');

export default {
  props: {
    inputData: {
      type: Object
    }
  },
  data() {
    return {
      startLoad: {
        done: false,
        threads: []
      },
      showLoading: false
    };
  },
  mounted() {
    const id = this.containerId;
    // console.log(id);
    this.viewer = new OpenSeadragon({
      id: id,
      prefixUrl: './static/openseadragon_images/'
    });
    this.fetchDeepzoomImage();
    this.viewerOpen();
  },
  destroyed() {
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },
  watch: {
    'inputData.dbImageInfo'() {
      this.fetchDeepzoomImage();
    },
   'inputData.dbImageInfo.deepzoom'() {
     this.viewerOpen();
   }
  },
  computed: {
    containerId() {
      return this.$getRandomId();
    }
  },
  methods: {
    prev() {
      this.$store.dispatch('archive.select.prevImageOfSlide');
    },
    next() {
      this.$store.dispatch('archive.select.nextImageOfSlide');
    },
    fetchDeepzoomImage() {
      const d = this.inputData;
      if (!d || !d.dbImageInfo) {
        return;
      }
      if (d.dbImageInfo.deepzoom) {
        this.viewerOpen();
        return;
      }
      if (!d.dbImageInfo.deepzoom && d.dbImageInfo.name && !d.dbImageInfo.inProgress) {
        d.dbImageInfo.inProgress = true;
        this.showLoading = true;
        this.viewer.close();
        this.$store.dispatch('fetchDeepZoomImageUrl', {
          startLoad: this.startLoad,
          dbImageInfo: d.dbImageInfo,
          cb: (data) => {
            d.dbImageInfo.inProgress = false;
            d.dbImageInfo.deepzoom = pkConfig.osdHostProtocol + pkConfig.osdHost + pkConfig.osdRoot  + data.data.output.DZI;
            this.viewerOpen();
          }
        });
      }
    },
    viewerOpen() {
      this.viewer.close();
      if (!this.inputData || !this.inputData.dbImageInfo || !this.inputData.dbImageInfo.deepzoom) {
        return;
      }
      this.showLoading = false;
      const url = this.inputData.dbImageInfo.deepzoom;
      this.viewer.open(url);
      this.addOverlay();
    },
    addOverlay() {
      const elt = document.createElement('div');
      elt.id = 'runtime-overlay';
      elt.className = 'highlight';
      const image = document.createElement('img');
      image.id = 'right-arrow-overlay';
      image.src = 'http://upload.wikimedia.org/wikipedia/commons/7/7a/Red_Arrow_Right.svg';
      image.width = '20';
      elt.appendChild(image);
      this.viewer.addOverlay({
        element: elt,
        px: 500,
        py: 200,
        checkResize: false,
        placement: OpenSeadragon.OverlayPlacement.CENTER
      });
    }
  }
};
</script>

<style>
  .pk-imageview {
    height: 100%;
    background-color: #ddd;
  }
  
  .pk-imageview-body img {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
  }
  
  .pk-imageview-side {
    width: auto;
    align-items: flex-end;
  }
  
  .pk-imageview-side img {
    width: 35px;
    height: 35px;
    cursor: pointer;
  }
  
  .pk-imageview-side img:hover {
    background-color: #fff;
  }
  
  #overlays-div {
    border: 1px solid red;
  }
</style>